<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'ALERTAS.LBL_PRINCIPAL' | translate }}">
        <div class="grid form-group">
          <div class="col-12 md:col-2 lg:col-2">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_CODIGO' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.codigo}}</label>
            </div>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_NOMBRE' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.nombre}}</label>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_TIPOALERTA' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.tipoAlerta}}</label>
            </div>
          </div>
          <div class="col-12 md:col-2 lg:col-2 ">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_ALERTAINTERNA' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.indicadorAlertaInterna ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</label>
            </div>
          </div>
        </div>
        <div class="grid form-group"
             *ngIf="(regPerfiles && regPerfiles.length > 0) || (regEstructurasFisicas && regEstructurasFisicas.length > 0)">
          <div class="col-12 md:col-6 lg:col-6" *ngIf="regPerfiles && regPerfiles.length > 0">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_PERFILES' | translate }}</label>
              <label class="falso-combo-texto">{{perfiles}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="regEstructurasFisicas && regEstructurasFisicas.length > 0">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_OFICINA' | translate }}</label>
              <label class="falso-combo-texto">{{oficinas}}</label>
            </div>
          </div>
        </div>
        <div class="grid form-group" *ngIf="detalle && detalle.idAlertaDetalle && detalle.indicadorHabilitado">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_NOTA' | translate }}</label>
              <label class="falso-combo-texto">{{detalle.notaInterna}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_VINCULACION' | translate }}</label>
              <label class="falso-combo-texto">{{vinculaciones}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_TIPOCREDITO' | translate }}: </label>
              <label class="falso-combo-texto">
                <span *ngIf="detalle.indicadorNuevoCredito">{{'ALERTAS.LBL_NUEVO'|translate}}</span>
                <span *ngIf="detalle.indicadorNuevoCredito && detalle.indicadorRenuevaCredito">, </span>
                <span *ngIf="detalle.indicadorRenuevaCredito">{{'ALERTAS.LBL_RENOVACION'|translate}}</span></label>
            </div>
          </div>
        </div>
        <hr>
        <div class="grid form-group" *ngIf="descarte && descarte.indicadorHabilitado">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_TIPOCONDICION' | translate }}</label>
              <label
                class="falso-combo-texto">{{descarte && descarte.indicadorHabilitado ? ('ALERTAS.LBL_DESCARTAR' | translate) : ('ALERTAS.LBL_ALERTA' | translate)}}</label>
            </div>
          </div>

        </div>
        <div class="grid form-group" *ngIf="descarte && descarte.idAlertaDescarte && descarte.indicadorHabilitado">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_TIPOCONDICION' | translate }}</label>
              <label
                class="falso-combo-texto">{{descarte && descarte.indicadorHabilitado ? ('ALERTAS.LBL_DESCARTAR' | translate) : ('ALERTAS.LBL_ALERTA' | translate)}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_ESTADO' | translate }}</label>
              <label
                class="falso-combo-texto">{{descarte.estadosNombre}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_CAUSAL' | translate }}</label>
              <label
                class="falso-combo-texto">{{descarte.listasTiposCausalesSolicitudesNombre}}</label>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_DESCRIPCION' | translate }}</label>
              <label
                class="falso-combo-texto">{{alerta.descripcion}}</label>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 md:col-2 md:col-offset-5 lg:col-2 lg:col-offset-5 text-center">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_HABILITADO' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</label>
            </div>
          </div>
        </div>
        <hr>
        <div class="grid" *ngIf="alerta">
          <div class="col-12 md:col-2 text-center">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_EXCEPCION' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.estadoAlertaExcepciones ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</label>
            </div>
          </div>
          <div class="col-12 md:col-2 text-center" *ngIf="alerta.estadoAlertaExcepciones">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_MANEJAADJUNTO' | translate }}</label>
              <label class="falso-combo-texto">{{alerta.indicadorManejaAdjunto ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="excepcion && excepcion.indicadorHabilitado">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_NIVELAPROBACION' | translate }}</label>
              <label
                class="falso-combo-texto">{{excepcion.nivelNombre}}</label>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12" *ngIf="alerta.estadoAlertaExcepciones">
            <div class="div-form">
              <label>{{ 'ALERTAS.LBL_DEFINICIONEXCEPCION' | translate}}</label>
              <label class="falso-combo-texto">{{alerta.descripcionExcepcion}}</label>
            </div>
          </div>
        </div>
      </p-panel>
      <div class="grid form-footer-buttons" *ngIf="alerta && alerta.idAlerta">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
